import { getCurrentReleaseManifest } from "./releaseManifest";

/**
 * Starts a release tour via the Product Education presentation layer.
 * Persistence is handled by the caller through ReleaseManager.
 */
export function createReleaseTourSession({
  releaseId,
  featureIds,
  allowSkip = false,
  allowHardwareBackDismiss = false,
  onComplete,
  onCancel,
}) {
  const manifest = getCurrentReleaseManifest(releaseId);

  return {
    releaseId,
    featureIds,
    allowSkip,
    allowHardwareBackDismiss,
    estimatedDurationMinutes: 1,
    releaseMeta: manifest?.meta || null,
    onComplete,
    onCancel,
  };
}

// Backward-compatible export for callers that still import the placeholder name.
export function startReleaseTourPlaceholder(options) {
  return createReleaseTourSession(options);
}
